export default __webpack_public_path__ + "static/media/crystal-skull.2fa40a12.png";